import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth'
import session from './session'
import visit from './visit'
import heatMap from './heatMap'
import menu from './menu'
import loader from './loader'
import dialogs from './dialogs'
import appointment from './appointment'
import subscription from './subscription'
import complexExercises from './complexExercises'
import thermogram from '@/store/thermogram'
import userDocuments from './userDocuments'

Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,
  modules: {
    dialogs,
    auth,
    session,
    visit,
    heatMap,
    menu,
    loader,
    appointment,
    subscription,
    complexExercises,
    thermogram,
    userDocuments,
  }
})
